<template>
    <div class="select">
        <div class="label text-xs-right" v-if="label">
            <span class="text-xs-right">{{ label }}</span>
        </div>
        <div :class="[{'disabled': disabled}]">
            <v-select
                v-model="result"
                :items="items"
                :label="placeholder"
                :multiple="multiple"
                :item-text="itemText"
                :item-value="itemValue"
                class="small darken no-margin"
                :class="[{'disabled': disabled}]"
                outline
                single-line
                :disabled="disabled"
                @change="onChange"
                :clearable="clearable"
                @input="onInput"
            ></v-select>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Select',
    props: {
        value: {
            type: [Object, Array, String, Number, null]
        },
        label: {
            type: String,
            required: false,
            default: null
        },
        placeholder: {
            type: String,
            required: false,
            default: 'Choose option...'
        },
        items: {
            type: Array,
            required: true
        },
        multiple: {
            type: Boolean,
            required: false,
            default: false
        },
        itemText: {
            type: String,
            required: false,
            default: 'text',
        },
        itemValue: {
            type: String,
            required: false,
            default: 'value',
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        onChange: {
            type: Function,
            required: false,
            default: () => {}
        },
        onInput: {
            type: Function,
            required: false,
            default: () => {}
        },
        clearable: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    computed: {
        result: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.disabled {
    opacity: 0.8;
    cursor: not-allowed;
}

.label {
    color: $inactive;
    font-size: 14px;
    margin-bottom: 4px;
}
</style>
